import React, { useState } from 'react';
import { FloatButton } from 'antd';
import { Button, Modal } from 'antd';

import PatientForm from './PatientForm';
import { usePatients } from '../../../hooks/usePatients';

import { IPatient } from '../../../interfaces/patient';

const AddPatient = () => {
  const { addPatient } = usePatients();
  const [visible, setVisible] = useState(false);

  const handleClick = () => setVisible(!visible);

  const closeModal = () => setVisible(false);

  const handleAddPatient = (patient: IPatient) => {
    addPatient(patient);
    closeModal();
  };

  return (
    <div className='add-patient'>
      <FloatButton
        className='float_button'
        onClick={handleClick}
        icon={<i className='icofont-ui-add'></i>}
      />

      <Modal
        open={visible}
        footer={null}
        onCancel={closeModal}
        destroyOnClose
        title={<h3 className='title'>Add patient</h3>}
      >
        <PatientForm onCancel={closeModal} onSubmit={handleAddPatient} />
      </Modal>
    </div>
  );
};

export default AddPatient;
